module.exports = __webpack_public_path__ + "static/media/1013165.33a499b3.png";